import { ContactTypeEnum } from '../enums';

export class ContactTypeInput {
    public name: string = '';
    public contactTypeEnum: ContactTypeEnum = ContactTypeEnum.Other;
}
